import React from 'react';
import { UserProfileDetailsProps } from '../types';
import { UserProfileDetails, UserProfileName, UserProfileRole } from './styled';

const UserProfileDetailsComponent = ({
  name,
  role
}: UserProfileDetailsProps) => {
  return (
    <UserProfileDetails>
      <UserProfileName variant='h6'>{name}</UserProfileName>
      <UserProfileRole variant='body2'>{role}</UserProfileRole>
    </UserProfileDetails>
  );
};

export default UserProfileDetailsComponent;
